import React, { useState } from 'react';
import { Select, SelectOption } from '../../ui';
import { useFetchEmailTemplatesRaw } from '../../../query/template';
import useDebounce from 'react-use/lib/useDebounce';

export default function TemplateSelector({
  selectedTemplateId,
  onTemplateChange,
  ...props
}) {
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  useDebounce(
    () => {
      setDebouncedSearch(search);
    },
    500,
    [search],
  );
  const { data = [], isFetching } = useFetchEmailTemplatesRaw({
    limit: 20,
    search: debouncedSearch,
    activeOnly: true,
  });
  const [templates = []] = data;
  return (
    <Select
      {...props}
      className="select-template__btn"
      filterOption={false}
      loading={isFetching}
      showSearch
      value={selectedTemplateId}
      onChange={id => {
        setSearch('');
        onTemplateChange(templates?.find(v => Number(v.id) === Number(id)));
      }}
      onSearch={setSearch}
    >
      <SelectOption key="default" value={-1}>
        {props.disabled ? '' : isFetching ? 'Searching...' : 'Select template'}
      </SelectOption>
      {templates.map(template => (
        <SelectOption key={template.id} value={template.id}>
          {`${template.id} - ${template.name}`}
        </SelectOption>
      ))}
    </Select>
  );
}
